module.exports = __webpack_public_path__ + "static/media/mooring.b8b17af2.svg";